import client from './httpClient';
import { addReasons } from './transformer';

export const reportListing = (issueReported, offerId, propertyId, issueReportedAt) => {
  const payload = addReasons(issueReported, offerId, propertyId, issueReportedAt);

  return client.post('exec', payload);
};
